export class MemberType {
  id: number;
  roleName: string;
  roleDescription: string;
  userId: number;
  roleId: number;
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/entities/memberType.ts